// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1r6H6","col":"styles_col__3-OYF"};